import { ServerFetch } from '../main-model'

export default class PaperLockModel extends ServerFetch {
    getPaperLockBy = (data) => this.authFetch({
        url: 'paper-lock/getPaperLockBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updatePaperLockBy = (data) => this.authFetch({
        url: 'paper-lock/updatePaperLockBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    createPaperLock = (data) => this.authFetch({
        url: 'paper-lock/createPaperLock',
        method: 'POST',
        body: JSON.stringify(data),
    })
}